import HowItWorks from '../../../website-mobile/components/HowItWorks/HowItWorks';
import '../../../website-mobile/mobile-scope.css';
import styles from './page4.module.css';

export default function Page4({ handleBtnClick }) {
    return (
        <div className={`${styles.page4} website-mobile-scope`} style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='31' y='31' width='2' height='2' fill='%2362A135'/%3E%3C/svg%3E")`, backgroundRepeat: 'repeat', backgroundSize: '64px 64px' }}>
            <div className={styles.contentWrapper}>
                <HowItWorks handleBtnClick={handleBtnClick} />
            </div>
        </div>
    );
}
